import AccommodationsPage from "./AccommodationsPage";

export default AccommodationsPage;
